const MediaTextareaReadMore = () => {

    // Handle "Read More" button
    const readMoreButton = document.getElementById('read-more');
    if (readMoreButton) {
        readMoreButton.addEventListener('click', () => {
            let offset = parseInt(readMoreButton.getAttribute('data-offset'), 10);
            const blocks = document.querySelectorAll('.media-textarea__row');
            const total = blocks.length;

            // Show the next set of blocks
            for (let i = offset; i < offset + 5 && i < total; i++) {
                blocks[i].style.display = 'flex';
            }

            // Update the offset
            offset += 5;
            readMoreButton.setAttribute('data-offset', offset);

            // Hide the button if all blocks are displayed
            if (offset >= total) {
                readMoreButton.style.display = 'none';
            }
        });
    }
}

export default MediaTextareaReadMore;
